/** Shown on the "Manage subscription & payment" switch for people who can't change it. */
export const MANAGE_SWITCH_LOCKED_NOTE =
  "Only people who manage the firm's subscription can change this.";

/** Admin note when the firm is billed per user (the billing switch is the exception). */
export const ADMIN_PERMISSIONS_NOTE_SEATS =
  "Admins have every permission except \"Manage subscription & payment\", which is turned on one by one. Pick another access level to choose the others one by one.";
